import React, { useEffect, useRef, useState } from 'react';
import Sidebar from '../../Components/Sidebar/Sidebar';
import verificandoApp from '../../../FuncoesGerais/verificaApp';
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import axios from 'axios';
import { ensureProtocol } from '../../../config/backend';
import {
  fetchHorarioEmpresa,
  salvarHorarioEmpresa,
  fetchFeriadosEmpresa,
  adicionarFeriadoEmpresa,
  removerFeriadoEmpresa,
  solicitarRecalculoSla,
  fetchEmpresaById,
  updateStatusConclusaoPrincipal,
} from '../../../api/empresas';
import './configEmpresa.css';

function ConfigEmpresa() {
  const [mensagem, setMensagem] = useState('');
  const [statusDisponiveis, setStatusDisponiveis] = useState([]);
  const [etapasSelecionadas, setEtapasSelecionadas] = useState({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [], EM_TESTE: [] });
  const [salvandoEtapas, setSalvandoEtapas] = useState(false);
  const [usaHorarioSla, setUsaHorarioSla] = useState(0);
  const [horaInicioPadrao, setHoraInicioPadrao] = useState('');
  const [horaFimPadrao, setHoraFimPadrao] = useState('');
  const [horaInicioAlmoco, setHoraInicioAlmoco] = useState('');
  const [horaFimAlmoco, setHoraFimAlmoco] = useState('');
  const [diasUteisPadrao, setDiasUteisPadrao] = useState('SEG-SEX');
  const [feriados, setFeriados] = useState([]);
  const [novoFeriadoData, setNovoFeriadoData] = useState('');
  const [novoFeriadoTipo, setNovoFeriadoTipo] = useState('FECHADO');
  const [novoFeriadoDescricao, setNovoFeriadoDescricao] = useState('');
  const [recalculandoSla, setRecalculandoSla] = useState(false);
  const [statusConclusaoPrincipalId, setStatusConclusaoPrincipalId] = useState('');
  const [salvandoStatusConclusao, setSalvandoStatusConclusao] = useState(false);
  const formCardRef = useRef(null);

  const empresaId = Number(localStorage.getItem('empresa_id') || 1);
  const empresaNome = localStorage.getItem('empresa_nome') || `Empresa ${empresaId}`;

  const baseUrlAnalista = () => {
    const ip = localStorage.getItem('ipBackend2') || '';
    return ip ? ensureProtocol(ip) : '';
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: token } : {};
  };

  useEffect(() => {
    (async () => {
      const ok = await verificandoApp('ATENDENTE');
      if (!ok) return;
      await carregarConfiguracoes();
      setTimeout(() => {
        formCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const carregarConfiguracoes = async () => {
    verificandoToken();
    const baseUrl = baseUrlAnalista();
    try {
      const [respStatus, respEtapas, horario, listaFeriados, empresa] = await Promise.all([
        axios.get(baseUrl + '/status-chamado', { headers: getAuthHeaders() }),
        axios.get(baseUrl + `/empresas/${empresaId}/etapas-chamado`, { headers: getAuthHeaders() }),
        fetchHorarioEmpresa(empresaId).catch(() => null),
        fetchFeriadosEmpresa(empresaId).catch(() => []),
        fetchEmpresaById(empresaId).catch(() => null),
      ]);
      const listaStatus = Array.isArray(respStatus.data) ? respStatus.data : [];
      const normalizada = listaStatus
        .map((s) => ({
          id: s.id ?? s.ID ?? s.codigo_legado,
          codigo_legado: s.codigo_legado ?? s.CODIGO_LEGADO ?? s.codigo ?? s.CODIGO,
          nome: s.nome ?? s.NOME ?? String(s.codigo_legado ?? s.CODIGO_LEGADO ?? ''),
          finalizacao: Number(s.finalizacao ?? s.FINALIZACAO ?? 0) === 1,
        }))
        .filter((s) => s.codigo_legado != null && s.nome);
      setStatusDisponiveis(normalizada);
      const etapas = (respEtapas.data && respEtapas.data.etapas) || {};
      setEtapasSelecionadas({
        SUPORTE: Array.isArray(etapas.SUPORTE) ? etapas.SUPORTE : [],
        ANALISE: Array.isArray(etapas.ANALISE) ? etapas.ANALISE : [],
        DESENVOLVIMENTO: Array.isArray(etapas.DESENVOLVIMENTO) ? etapas.DESENVOLVIMENTO : [],
        EM_TESTE: Array.isArray(etapas.EM_TESTE) ? etapas.EM_TESTE : [],
      });
      if (horario && horario.empresa_id) {
        setUsaHorarioSla(horario.usa_horario_funcionamento_sla != null ? Number(horario.usa_horario_funcionamento_sla) : 0);
        setHoraInicioPadrao(horario.hora_inicio_padrao ? String(horario.hora_inicio_padrao).substring(0, 5) : '');
        setHoraFimPadrao(horario.hora_fim_padrao ? String(horario.hora_fim_padrao).substring(0, 5) : '');
        setHoraInicioAlmoco(horario.hora_inicio_almoco ? String(horario.hora_inicio_almoco).substring(0, 5) : '');
        setHoraFimAlmoco(horario.hora_fim_almoco ? String(horario.hora_fim_almoco).substring(0, 5) : '');
        setDiasUteisPadrao(horario.dias_uteis_padrao || 'SEG-SEX');
      } else {
        setUsaHorarioSla(0);
        setHoraInicioPadrao('');
        setHoraFimPadrao('');
        setDiasUteisPadrao('SEG-SEX');
      }
      setFeriados(Array.isArray(listaFeriados) ? listaFeriados : []);
      const statusConcId = empresa?.status_conclusao_principal_id;
      setStatusConclusaoPrincipalId(statusConcId != null && statusConcId !== '' ? String(statusConcId) : '');
    } catch (e) {
      console.error('Erro ao carregar configuração da empresa:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao carregar configuração da empresa.');
      setStatusDisponiveis([]);
      setEtapasSelecionadas({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [], EM_TESTE: [] });
      setUsaHorarioSla(0);
      setHoraInicioPadrao('');
      setHoraFimPadrao('');
      setDiasUteisPadrao('SEG-SEX');
      setFeriados([]);
      setStatusConclusaoPrincipalId('');
    }
  };

  const salvarStatusConclusaoPrincipal = async () => {
    setSalvandoStatusConclusao(true);
    try {
      await updateStatusConclusaoPrincipal(
        empresaId,
        statusConclusaoPrincipalId === '' || statusConclusaoPrincipalId == null ? null : Number(statusConclusaoPrincipalId)
      );
      setMensagem('Status de conclusão principal salvo. Ao clicar em "Concluir chamado", o chamado será alterado para este status.');
    } catch (e) {
      console.error('Erro ao salvar status de conclusão principal:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao salvar status de conclusão principal.');
    } finally {
      setSalvandoStatusConclusao(false);
    }
  };

  const toggleEtapaStatus = (tipo, codigoLegado) => {
    setEtapasSelecionadas((prev) => {
      const atual = Array.isArray(prev[tipo]) ? prev[tipo] : [];
      const cod = typeof codigoLegado === 'number' ? codigoLegado : parseInt(String(codigoLegado), 10);
      if (Number.isNaN(cod)) return prev;
      const jaTem = atual.includes(cod);
      const novo = jaTem ? atual.filter((c) => c !== cod) : [...atual, cod];
      return { ...prev, [tipo]: novo };
    });
  };

  const salvarEtapasChamado = async () => {
    verificandoToken();
    const baseUrl = baseUrlAnalista();
    setSalvandoEtapas(true);
    try {
      await axios.put(
        baseUrl + `/empresas/${empresaId}/etapas-chamado`,
        { etapas: etapasSelecionadas },
        { headers: getAuthHeaders() }
      );
      setMensagem('Etapas do chamado salvas com sucesso.');
    } catch (e) {
      console.error('Erro ao salvar etapas do chamado:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao salvar etapas do chamado desta empresa.');
    } finally {
      setSalvandoEtapas(false);
    }
  };

  const salvarHorario = async () => {
    if (usaHorarioSla === 1 && (!horaInicioPadrao || !horaFimPadrao)) {
      setMensagem('Informe horário de início e fim para usar horário de funcionamento na SLA.');
      return;
    }
    if ((horaInicioAlmoco && !horaFimAlmoco) || (!horaInicioAlmoco && horaFimAlmoco)) {
      setMensagem('Para o intervalo de almoço, informe a saída e a volta (ou deixe ambos em branco).');
      return;
    }
    if (horaInicioAlmoco && horaFimAlmoco && horaFimAlmoco <= horaInicioAlmoco) {
      setMensagem('A volta do almoço deve ser após a saída para o almoço.');
      return;
    }
    try {
      await salvarHorarioEmpresa(empresaId, {
        usa_horario_funcionamento_sla: usaHorarioSla,
        hora_inicio_padrao: horaInicioPadrao ? `${horaInicioPadrao}:00` : null,
        hora_fim_padrao: horaFimPadrao ? `${horaFimPadrao}:00` : null,
        hora_inicio_almoco: horaInicioAlmoco ? `${horaInicioAlmoco}:00` : null,
        hora_fim_almoco: horaFimAlmoco ? `${horaFimAlmoco}:00` : null,
        dias_uteis_padrao: diasUteisPadrao || null,
      });
      setMensagem('Horário de funcionamento salvo com sucesso.');
    } catch (e) {
      console.error('Erro ao salvar horário de funcionamento:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao salvar horário de funcionamento desta empresa.');
    }
  };

  const adicionarFeriado = async () => {
    if (!novoFeriadoData) {
      setMensagem('Informe a data do feriado.');
      return;
    }
    try {
      await adicionarFeriadoEmpresa(empresaId, {
        data: novoFeriadoData,
        tipo: novoFeriadoTipo,
        descricao: novoFeriadoDescricao || null,
      });
      setNovoFeriadoData('');
      setNovoFeriadoTipo('FECHADO');
      setNovoFeriadoDescricao('');
      const lista = await fetchFeriadosEmpresa(empresaId);
      setFeriados(Array.isArray(lista) ? lista : []);
    } catch (e) {
      console.error('Erro ao adicionar feriado:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao adicionar feriado desta empresa.');
    }
  };

  const excluirFeriado = async (feriadoId) => {
    if (!feriadoId) return;
    try {
      await removerFeriadoEmpresa(empresaId, feriadoId);
      setFeriados((prev) => prev.filter((f) => f.id !== feriadoId));
    } catch (e) {
      console.error('Erro ao remover feriado:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao remover feriado desta empresa.');
    }
  };

  const dispararRecalculoSla = async () => {
    setRecalculandoSla(true);
    try {
      await solicitarRecalculoSla(empresaId);
      setMensagem('Solicitação de recálculo de SLA registrada. Os próximos indicadores já considerarão o horário de funcionamento.');
    } catch (e) {
      console.error('Erro ao solicitar recálculo de SLA:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao solicitar recálculo de SLA.');
    } finally {
      setRecalculandoSla(false);
    }
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo cadastro-unificado config-empresa-page" ref={formCardRef}>
          <div className="page-header">
            <h1>Configuração da empresa</h1>
            <p className="text-muted mb-0">Empresa atual: <strong>{empresaNome}</strong> (ID {empresaId})</p>
          </div>
          {mensagem && (
            <div className={`msg ${mensagem.includes('Erro') ? 'erro' : 'sucesso'}`}>{mensagem}</div>
          )}
          <div className="card card-form mb-3">
            <div className="card-body">
              <h5 className="card-title">Etapas do chamado para esta empresa</h5>
              <p className="text-muted small">
                Selecione, para esta empresa, quais <strong>status de chamado</strong> representam cada etapa:
                <strong> Suporte normal</strong>, <strong>Análise de requisitos</strong>, <strong>Em desenvolvimento</strong> e <strong>Em teste</strong>.
              </p>
              <div className="row">
                {['SUPORTE', 'ANALISE', 'DESENVOLVIMENTO', 'EM_TESTE'].map((tipo) => (
                  <div className="col-md-6 col-lg-3 mb-3" key={tipo}>
                    <div className="card h-100">
                      <div className="card-body p-2">
                        <h6 className="card-title mb-1">
                          {tipo === 'SUPORTE' && 'Suporte normal'}
                          {tipo === 'ANALISE' && 'Análise de requisitos'}
                          {tipo === 'DESENVOLVIMENTO' && 'Em desenvolvimento'}
                          {tipo === 'EM_TESTE' && 'Em teste'}
                        </h6>
                        <div className="empresas-etapas-status-lista">
                          {statusDisponiveis.length === 0 && (
                            <p className="text-muted small mb-0">Nenhum status carregado.</p>
                          )}
                          {statusDisponiveis.map((st) => {
                            const cod = st.codigo_legado;
                            const selecionados = etapasSelecionadas[tipo] || [];
                            const marcado = selecionados.includes(cod) || selecionados.includes(Number(cod));
                            return (
                              <div className="form-check form-check-sm" key={`${tipo}-${cod}`}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`cfg-${empresaId}-${tipo}-${cod}`}
                                  checked={marcado}
                                  onChange={() => toggleEtapaStatus(tipo, cod)}
                                />
                                <label className="form-check-label" htmlFor={`cfg-${empresaId}-${tipo}-${cod}`}>
                                  {st.nome} <span className="text-muted small">({cod})</span>
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <button
                type="button"
                className="btn btn-secondary btn-sm mt-1 mb-3"
                onClick={salvarEtapasChamado}
                disabled={salvandoEtapas}
              >
                {salvandoEtapas ? 'Salvando etapas...' : 'Salvar etapas do chamado desta empresa'}
              </button>

              <hr />
              <h5 className="card-title mt-3">Status de conclusão principal</h5>
              <p className="text-muted small">
                Ao clicar em &quot;Concluir chamado&quot; na tela do chamado, o sistema altera o status do chamado para o status selecionado abaixo.
              </p>
              <div className="row align-items-end">
                <div className="col-md-6">
                  <div className="form-group mb-2">
                    <label>Status ao concluir chamado</label>
                    <select
                      value={statusConclusaoPrincipalId}
                      onChange={(e) => setStatusConclusaoPrincipalId(e.target.value)}
                      className="form-control form-control-sm"
                      title="Status aplicado ao clicar em Concluir chamado"
                    >
                      <option value="">— Nenhum (usar primeiro status de conclusão do cadastro)</option>
                      {statusDisponiveis.filter((s) => s.finalizacao).map((s) => (
                        <option key={s.id} value={s.id}>{s.nome}</option>
                      ))}
                    </select>
                    {statusDisponiveis.length > 0 && statusDisponiveis.filter((s) => s.finalizacao).length === 0 && (
                      <small className="text-warning">Nenhum status marcado como finalização no cadastro de Status de chamado. Marque &quot;É finalização&quot; nos status desejados (Cadastros → Status de chamado).</small>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={salvarStatusConclusaoPrincipal}
                    disabled={salvandoStatusConclusao}
                  >
                    {salvandoStatusConclusao ? 'Salvando...' : 'Salvar'}
                  </button>
                </div>
              </div>

              <hr />
              <h5 className="card-title mt-3">Horário de funcionamento / SLA</h5>
              <p className="text-muted small">
                Configure o horário de funcionamento da empresa. Quando a opção estiver ativada, a SLA será contada apenas dentro desse horário (horas úteis).
              </p>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group mb-2">
                    <label>Usar horário de funcionamento na SLA</label>
                    <select
                      value={usaHorarioSla}
                      onChange={(e) => setUsaHorarioSla(Number(e.target.value))}
                      className="form-control form-control-sm"
                    >
                      <option value={0}>Não</option>
                      <option value={1}>Sim</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-2">
                    <label>Horário de início</label>
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={horaInicioPadrao}
                      onChange={(e) => setHoraInicioPadrao(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-2">
                    <label>Saída p/ almoço</label>
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={horaInicioAlmoco}
                      onChange={(e) => setHoraInicioAlmoco(e.target.value)}
                    />
                    <small className="text-muted">Opcional</small>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-2">
                    <label>Volta do almoço</label>
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={horaFimAlmoco}
                      onChange={(e) => setHoraFimAlmoco(e.target.value)}
                    />
                    <small className="text-muted">Opcional</small>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-2">
                    <label>Horário de fim</label>
                    <input
                      type="time"
                      className="form-control form-control-sm"
                      value={horaFimPadrao}
                      onChange={(e) => setHoraFimPadrao(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group mb-2">
                    <label>Dias úteis padrão</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={diasUteisPadrao}
                      onChange={(e) => setDiasUteisPadrao(e.target.value)}
                      placeholder="Ex.: SEG-SEX ou SEG-SAB"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm mt-1"
                    onClick={salvarHorario}
                  >
                    Salvar horário de funcionamento
                  </button>
                </div>
              </div>

              <hr />
              <h5 className="card-title mt-3">Feriados e expedientes especiais</h5>
              <p className="text-muted small">
                Cadastre feriados (dia todo fechado) ou, futuramente, dias com horário reduzido. Esses dias não contam (ou contam parcialmente) para a SLA em horas úteis.
              </p>
              <div className="row align-items-end">
                <div className="col-md-3">
                  <div className="form-group mb-2">
                    <label>Data</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={novoFeriadoData}
                      onChange={(e) => setNovoFeriadoData(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group mb-2">
                    <label>Tipo</label>
                    <select
                      className="form-control form-control-sm"
                      value={novoFeriadoTipo}
                      onChange={(e) => setNovoFeriadoTipo(e.target.value)}
                    >
                      <option value="FECHADO">Fechado</option>
                      <option value="HORARIO_REDUZIDO">Horário reduzido</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-2">
                    <label>Descrição</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={novoFeriadoDescricao}
                      onChange={(e) => setNovoFeriadoDescricao(e.target.value)}
                      placeholder="Ex.: Feriado municipal"
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={adicionarFeriado}
                  >
                    Adicionar
                  </button>
                </div>
              </div>
              <div className="table-responsive mt-2">
                <table className="table table-sm table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Tipo</th>
                      <th>Descrição</th>
                      <th style={{ width: 60 }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(!feriados || feriados.length === 0) && (
                      <tr>
                        <td colSpan="4" className="text-muted small text-center">
                          Nenhum feriado cadastrado.
                        </td>
                      </tr>
                    )}
                    {feriados && feriados.map((f) => (
                      <tr key={f.id}>
                        <td>{f.data ? String(f.data).substring(0, 10) : ''}</td>
                        <td>{f.tipo}</td>
                        <td>{f.descricao || ''}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-link btn-sm text-danger p-0"
                            title="Remover"
                            onClick={() => excluirFeriado(f.id)}
                          >
                            <i className="fas fa-trash" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <hr />
              <h5 className="card-title mt-3">Recalcular SLA histórico</h5>
              <p className="text-muted small">
                Use este botão quando ajustar o horário de funcionamento ou feriados da empresa. Os indicadores de SLA e tempo médio são calculados em tempo real; esta ação apenas força a validação da configuração e registra a intenção de recalcular.
              </p>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={dispararRecalculoSla}
                disabled={recalculandoSla}
              >
                {recalculandoSla ? 'Validando configuração de SLA...' : 'Recalcular SLA histórico'}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ConfigEmpresa;

